import styled from 'styled-components';
import device from '../../../../components/mediaQueries';

const SocialImg = styled.img`
  width: ${({ width }) => (width ? width : 'initial')};
  ${device.mobile`
    margin: 0 10px;
  `}

  ${device.desktop`
    margin: ${({ index }) => (index === 0 ? '0 5px 0 0' : '0 5px')}
  `}
  user-select: none;
`;
export default SocialImg;
